var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnchorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.33333V16M8.5 7.33333C7.92536 7.33333 7.37426 7.10506 6.96793 6.69873C6.56161 6.2924 6.33333 5.7413 6.33333 5.16667C6.33333 4.59203 6.56161 4.04093 6.96793 3.6346C7.37426 3.22827 7.92536 3 8.5 3C9.07464 3 9.62574 3.22827 10.0321 3.6346C10.4384 4.04093 10.6667 4.59203 10.6667 5.16667C10.6667 5.7413 10.4384 6.2924 10.0321 6.69873C9.62574 7.10506 9.07464 7.33333 8.5 7.33333ZM8.5 16C6.96764 16 5.49804 15.3913 4.41449 14.3077C3.33095 13.2242 2.72222 11.7546 2.72222 10.2222M8.5 16C10.0324 16 11.502 15.3913 12.5855 14.3077C13.669 13.2242 14.2778 11.7546 14.2778 10.2222M15 10.2222H13.5556M3.44444 10.2222H2",
    stroke: "#EB564F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorIcon);
export default __webpack_public_path__ + "static/media/anchorIcon.f2694e58f023bec65173efff516a28af.svg";
export { ForwardRef as ReactComponent };